import { Text } from '../ui/Typography';
import { cn } from '../../utils/cn';

interface Step {
  id: string;
  label: string;
  icon: string;
}

interface ProgressStepperProps {
  steps: Step[];
  currentStep: string;
}

export function ProgressStepper({ steps, currentStep }: ProgressStepperProps) {
  const currentStepIndex = steps.findIndex(s => s.id === currentStep);

  return (
    <div className="flex items-center justify-between">
      {steps.map((step, index) => {
        const isCompleted = index < currentStepIndex;
        const isCurrent = index === currentStepIndex;
        // const _isFuture = index > currentStepIndex;

        return (
          <div key={step.id} className="flex items-center">
            <div className="flex flex-col items-center">
              {/* Step Circle */}
              <div
                className={cn(
                  'w-12 h-12 rounded-full flex items-center justify-center text-2xl transition-all duration-300',
                  isCompleted && 'scale-100',
                  isCurrent && 'scale-110 shadow-lg',
                  !isCompleted && !isCurrent && 'scale-100'
                )}
                style={{
                  backgroundColor: isCompleted
                    ? 'rgb(var(--color-success))'
                    : isCurrent
                    ? 'rgb(var(--color-primary))'
                    : 'rgb(var(--color-border))',
                  color: isCompleted || isCurrent
                    ? 'rgb(var(--color-primary-foreground))'
                    : 'rgb(var(--color-text-tertiary))',
                  boxShadow: isCurrent ? 'var(--shadow-lg)' : 'none',
                  transition: 'var(--transition-smooth)',
                }}
              >
                {isCompleted ? '✓' : step.icon}
              </div>
              
              {/* Step Label */}
              <Text
                size="xs"
                weight={isCurrent ? 'semibold' : 'medium'}
                className="mt-2 transition-colors duration-300"
                style={{
                  color: isCurrent
                    ? 'rgb(var(--color-primary))'
                    : isCompleted
                    ? 'rgb(var(--color-success))'
                    : 'rgb(var(--color-text-tertiary))',
                }}
              >
                {step.label}
              </Text>
            </div>

            {/* Connector Line */}
            {index < steps.length - 1 && (
              <div
                className="w-16 h-1 mx-2 transition-all duration-500"
                style={{
                  backgroundColor: index < currentStepIndex
                    ? 'rgb(var(--color-success))'
                    : 'rgb(var(--color-border))',
                  transition: 'var(--transition-smooth)',
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
